require('./blocks/news/news');
require('./blocks/action-detail.js');
require('./blocks/soc-area.less');
require('./blocks/nav-link.less');
require('./blocks/brochure.less');
require('./blocks/brochure-slider/brochure-slider');
require('./blocks/product/product');
require('./blocks/products-slider/products-slider');
require('./blocks/impromptu/impromptu-one-click');
require('form-serializer');



// WEBPACK FOOTER //
// ./news_detail.js